const partnerLinks = (state: any) => state.aftermarketPartner.partnerLinks;
const isIntegrationAdminAccount = (state: any) => state.aftermarketPartner.isIntegrationAdminAccount;

export const aftermarketPartnerSelectors = {
  partnerLinks,
  isIntegrationAdminAccount,
};
